/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
import _regeneratorRuntime from "E:\\ysh\\wx-master\\node_modules\\_@babel_runtime@7.16.5@@babel\\runtime\\regenerator\\index.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
/*
 * @Description:
 * @Date: 2021-07-28 09:56:18
 */


import { registUser } from '@/api/ajax';
export default function () {
  return _ref.apply(this, arguments);
}

function _ref() {
  _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _this = this;

    var _this$$route$query, phone, platform, _this$$store$state$wx, userId, wxOpenId;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _this$$route$query = this.$route.query, phone = _this$$route$query.phone, platform = _this$$route$query.platform;
            _this$$store$state$wx = this.$store.state.wxUserInfo, userId = _this$$store$state$wx.id, wxOpenId = _this$$store$state$wx.wxOpenId;

            if (platform === 'jhss' && phone && !userId) {
              registUser({
                phone: phone,
                wxOpenId: wxOpenId
              }).then(function (res) {
                var _res$data = res.data,
                    data = _res$data.data,
                    status = _res$data.status;

                if (status == '1') {
                  _this.$sa.login(data);

                  _this.$store.dispatch('wxUserInfoAction', data);

                  window.location.reload();
                }
              });
            }

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _ref.apply(this, arguments);
}